import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable()
export class StylesBundleService {

  constructor(@Inject(DOCUMENT) private document: Document) 
  {

  }

  loadThemes(lang: string) {
    if (lang == "ar") {
      this.loadStyleBundle('BBSF-Bundle-Arabic.css')
      document.querySelector('html').setAttribute("lang", "ar");
      document.querySelector('html').setAttribute("dir", "rtl");
    } else {
      this.loadStyleBundle('BBSF-Bundle-English.css')
      document.querySelector('html').setAttribute("lang", "en");
      document.querySelector('html').setAttribute("dir", "ltr");

    }
  }

  loadStyleBundle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;

    if (themeLink && themeLink.href.includes(styleName)) {
      return;
    }
    else if (themeLink && !themeLink.href.includes(styleName)) {
      themeLink.remove();
    }

    const style = this.document.createElement('link');
    style.id = 'client-theme';
    style.rel = 'stylesheet';
    style.href = `${styleName}`;
    head.appendChild(style);

  }
}

